// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import VueResource from 'vue-resource';
import 'element-ui/lib/theme-default/index.css';
import ElementUI from 'element-ui';
import router from './router';
import store from './store';
import App from './App';
import "babel-polyfill";

Vue.use(ElementUI);
Vue.use(VueResource);

// ajax拦截器
Vue.http.interceptors.push((request, next) => {
    next((response) => {
        switch (response.body.status) {
            case 302:
                // 重定向到登录页
                router.push({
                    name: 'Login'
                });
                break;
            default:
                if (typeof response.body === 'string') {
                    response.body = JSON.parse(response.body);
                }
                return response;
        }
    });
});

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');


// WEBPACK FOOTER //
// ./src/main.js